<div class="add-container">
    <h1 class="add-title">Repartizare în masă cereri</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="add-field">
            <mat-form-field>
                <mat-label>Direcție</mat-label>
                <mat-select formControlName="directie_id" (openedChange)="onDirectieClosed()"
                    (selectionChange)="onDirectieChange($event.value)">
                    <mat-form-field class="px-2 sticky-input">
                        <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                            (click)="$event.stopPropagation()" />
                    </mat-form-field>

                    <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                        <span>Nu au fost găsite direcții</span>
                    </mat-option>

                    <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                        {{ directie.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!form.controls['directie_id'].valid && form.controls['directie_id'].touched">
                    Câmp obligatoriu
                </mat-error>
            </mat-form-field>
        </div>

        <div class="add-field">
            <mat-form-field>
                <mat-label>Compartiment</mat-label>
                <mat-select formControlName="compartiment_id" (openedChange)="onCompartimentClosed()"
                    (selectionChange)="onCompartimentChange($event.value)">
                    <mat-form-field class="px-2 sticky-input">
                        <input matInput [formControl]="compartimenteControl" (keydown)="$event.stopPropagation()"
                            (click)="$event.stopPropagation()" />
                    </mat-form-field>

                    <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                        <span>Nu au fost găsite compartimente</span>
                    </mat-option>

                    <mat-option *ngFor="let compartiment of filteredCompartimente" [value]="compartiment.id">
                        {{ compartiment.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="add-field">
            <mat-form-field>
                <mat-label>Operator</mat-label>
                <mat-select formControlName="operator" (openedChange)="onUsersClosed()">
                    <mat-form-field class="px-2 sticky-input">
                        <input matInput [formControl]="usersControl" (keydown)="$event.stopPropagation()"
                            (click)="$event.stopPropagation()" />
                    </mat-form-field>

                    <mat-option *ngIf="filteredUsers.length === 0" disabled>
                        <span>Nu au fost găsiți operatori</span>
                    </mat-option>

                    <mat-option *ngFor="let user of filteredUsers" [value]="user.id">
                        {{ user.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="d-flex gap-2 justify-content-between flex-wrap">
            <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>